import GameUtil from "../../../utility/game_util";

//考虑本项目中 采取到对象池的只有一种 所以采取简单的实现方式

const { ccclass, property } = cc._decorator;

@ccclass
export default class NodePoolUtil extends cc.Component {
    @property(cc.Prefab)
    itemPrefab:cc.Prefab = null

    @property(cc.Node)
    parentNode:cc.Node = null

    nodePool = null

    initNodePool(initCount:number){
        this.nodePool = new cc.NodePool();
        for (let i = 0; i < initCount; ++i) {
            let enemy = cc.instantiate(this.itemPrefab); // 创建节点
            this.nodePool.put(enemy); // 通过 put 接口放入对象池
        }
    }
    
    //从对象池中取出一个
    getNode(countType:number):cc.Sprite {
        let nodeObj = null;
        if (this.nodePool.size() > 0) { // 通过 size 接口判断对象池中是否有空闲的对象
            nodeObj = this.nodePool.get();
        } else { // 如果没有空闲对象，也就是对象池中备用对象不够时，我们就用 cc.instantiate 重新创建
            nodeObj = cc.instantiate(this.itemPrefab)
        }
        //nodeObj.parent = this.parentNode; 
        this.parentNode.addChild(nodeObj)
        let countLab = cc.find("Count", nodeObj).getComponent(cc.Label)
        let str = countType == 0 ? "" : (GameUtil.currencyFormatting(countType, 2, true)).replace(".", "&")
        countLab.string = str
        return nodeObj.getComponent(cc.Sprite)
    }

    //放回池
    setNode(nodeSpr:cc.Sprite){
        this.nodePool.put(nodeSpr.node)
    }

    clear(){
        this.nodePool.clear()
    }

}